



































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DeviceVirtualList from '@/pages/groups/GroupTabs/DeviceVirtualList.vue';

@Component({
    components: {
        DeviceVirtualList
    }
})
class OverviewTab extends Vue {
    @Prop() list;
    @Prop() total;
}

export default OverviewTab;
